import { Controller } from "@hotwired/stimulus"

// Contrôleur pour afficher/masquer la description d'un article
// Utilisé dans le catalogue produits du POS
export default class extends Controller {
  static targets = ["description", "icon"]

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    
    if (this.hasDescriptionTarget) {
      this.descriptionTarget.classList.toggle("hidden")
      
      // Changer l'icône si nécessaire
      if (this.hasIconTarget) {
        const isExpanded = !this.descriptionTarget.classList.contains("hidden")
        this.iconTarget.classList.toggle("text-gray-400", !isExpanded)
        this.iconTarget.classList.toggle("text-blue-500", isExpanded)
      }
    }
  }
}
